import { Flex, Skeleton } from '@kognitos/lattice';
import { IDPDocumentSkeleton } from './IDPDocumentSkeleton';

/** Field rows in the loading list: a label over a value box. */
const FIELD_ROWS = 6;

/**
 * Suspense fallback for the lazily-loaded `IDPInlinePanel`. The panel chunk is
 * heavy (react-pdf + react-konva), so on first open it takes a beat to download;
 * without this the dialog shows a blank box until the chunk resolves. Shaped
 * like the panel, so nothing jumps when it arrives.
 */
export function IDPPanelLoading() {
  return (
    <Flex
      gap={4}
      className="h-full w-full flex-1 overflow-hidden"
      data-testid="idp-panel-loading"
    >
      <Flex justify="center" className="h-full flex-1 overflow-hidden pt-4">
        <div className="aspect-[1/1.3] h-full max-w-full rounded-sm bg-card ring-1 ring-border">
          <IDPDocumentSkeleton />
        </div>
      </Flex>
      <Flex
        direction="column"
        gap={4}
        padding={4}
        className="h-full w-[30%] shrink-0 overflow-hidden"
      >
        <Skeleton className="h-5 w-2/5" />
        {Array.from({ length: FIELD_ROWS }, (_, index) => (
          <Flex key={index} direction="column" gap={2}>
            <Skeleton className="h-3 w-1/3" />
            <Skeleton className="h-8 w-full" />
          </Flex>
        ))}
      </Flex>
    </Flex>
  );
}
